module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-Bold.a13c8325.woff";